import BaseHandler from "../BaseHandler";
import { UserTwoStepVerificationRequestRecoveryTokenResponse } from "../../proto/UserTwoStepVerificationRequestRecoveryToken_pb";
import { memoryHistory } from "../../index";
import { ROUTE_LOGIN_RECOVERY_EMAIL } from "../../constants/routes";

export default class HandleUserTwoStepVerificationRequestRecoveryTokenResponse extends BaseHandler<UserTwoStepVerificationRequestRecoveryTokenResponse> {
  handle() {
    memoryHistory.push(ROUTE_LOGIN_RECOVERY_EMAIL);
  }
}
